/**
 * Athos integration initialization
 *
 * Registers all Athos custom elements for search, collections, and product
 * recommendations. Components are imported statically so they compile into the
 * main `theme.js` bundle (no runtime code-splitting / dynamic `import()`), which
 * avoids async-chunk loading issues on Shopify's CDN.
 */

import register from 'preact-custom-element'

import { WrappedQuickSearch } from 'libs/athos/components/quick-search/QuickSearch'
import { WrappedSearchGrid } from 'libs/athos/components/SearchGrid'
import { WrappedCollectionGrid } from 'libs/athos/components/collection/CollectionGrid'

import {
  CarouselCollection,
  CarouselRecommend,
  GridRecommend,
  observedAttributes
} from 'libs/athos/components/recommendations/Recommendations'

import { CarouselTabbed } from 'libs/athos/components/recommendations/CarouselTabbed'

register(WrappedQuickSearch, 'x-recs-quick-search')
register(WrappedSearchGrid, 'x-recs-search-grid')
register(WrappedCollectionGrid, 'x-recs-collection-grid', ['per-page'], { shadow: false })

register(CarouselRecommend, 'x-recs-recommend-carousel', observedAttributes, { shadow: false })
register(CarouselCollection, 'x-recs-recommend-collection', observedAttributes, { shadow: false })
register(GridRecommend, 'x-recs-recommend-grid', observedAttributes, { shadow: false })
register(CarouselTabbed, 'x-recs-recommend-tabbed', observedAttributes, { shadow: false })
